"use strict";

require("core-js/modules/es.string.trim");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isPhoneWithSpaces = function isPhoneWithSpaces(message) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    }

    if (field.value && typeof field.value === 'string') {
      field.value = field.value.trim();
    }

    var isValid = false;
    var containsNoLetters = !/([a-zA-Z])+/.test(field.value);

    if (containsNoLetters) {
      // we accept numbers 0-9 and special characters (, ), +
      isValid = /^(?!00)([0-9()+ ])+$/.test(field.value);
    }

    return [isValid, message || 'Please enter phone number with numbers 0-9 and special characters (, ), +'];
  };
};

var _default = isPhoneWithSpaces;
exports.default = _default;
//# sourceMappingURL=isPhoneWithSpaces.js.map